export enum MemberFieldTypes {
    UnSpecified = 0,
    UniqueId = 1,
    FirstName = 2,
    LastName = 3,
    Email = 4,
    Email2 = 5,
    Address = 6,
    PostalArea = 7,
    PostalCode = 8,
    Country = 9,
    PhoneNumber = 10,
    Title = 11,
    Company = 12,
    Extra1 = 13,
    Extra2 = 14,
    Extra3 = 15,
    Status = 16,
    Group = 17,
    Payment = 18,
    EmailNotificationPreference = 19,
    SortOrder = 20,
    PersonalNumber = 21,
    PhoneNumber2 = 22,
    AdressRow2 = 23,
    AdressRow3 = 24,
    JoinedDate = 25,
    WebPage = 26,
    Custom = 27,
    Membership = 28,
    MembershipAddon = 29,
    /** Synthetic upload-template column (primary member's member number) — family import only. */
    PrimaryMemberNumber = 30,
    /** View-only column (member views): when the member was last modified. */
    LastModified = 31,
    /** View-only column (member views): when the member was created. */
    Created = 32,
}